import * as tslib_1 from "tslib";
import { FieldType } from '@ngx-formly/core';
var FormlyFieldObjectTypeChooserComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FormlyFieldObjectTypeChooserComponent, _super);
    function FormlyFieldObjectTypeChooserComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FormlyFieldObjectTypeChooserComponent;
}(FieldType));
export { FormlyFieldObjectTypeChooserComponent };
